import { bookingType } from "data/types";
import React, { FC, useCallback, useState } from "react";
import dayjs from "dayjs";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import useAuth from "components/Authprovider/Auth";
import toast from "react-hot-toast";
import { reLoadPage } from "hooks/reLoadPage";


export interface BookCardProps {
  className?: string;
  data: bookingType;
}

const BookCard: FC<BookCardProps> = ({ className = "", data }) => {

  const [isOpen, setIsOpen] = useState(false);
 

  const {token,user} = useAuth()

  const handleDlete = async ()=>{

    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json","Authorization": "Bearer " +token},
    };

    const deleteBooking = fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+data.hotel_id+'/bookings/'+data.id, requestOptions)
    
    toast.promise(deleteBooking, {
      loading: "Deleting a booking....",
      success: (data: any) => `Successful`,
      error: (error) => `Unable to delete booking`,
    });

    deleteBooking.then((data: any) => {
      // Reload the bookings
      reLoadPage()
    });
    
  }
  
  const checkIn = dayjs(data.check_in_date).format("DD-MMMM-YYYY")
  const checkOut = dayjs(data.check_out_date).format("DD-MMMM-YYYY")

  const renderDetailTop = () => {
    return (
      <div>
        <div className="flex flex-col md:flex-row ">
          <div className="w-24 md:w-20 lg:w-24 flex-shrink-0 md:pt-7">
            <span className="w-10 h-10 text-neutral-500 font-extrabold text-xl" >
              <i className="la la-clock" aria-hidden="true"></i>
            </span>
          </div>
          <div className="flex my-5 md:my-0">
            <div className="flex-shrink-0 flex flex-col items-center py-2">
              <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
              <span className="block flex-grow border-l border-neutral-400 border-dashed my-1"></span>
              <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
            </div>
            <div className="ml-4 space-y-10 text-sm">
              <div className="flex flex-col space-y-1">
                <span className=" text-neutral-500 dark:text-neutral-400">
                 {checkIn}
                </span>
                <span className=" font-semibold">
                  {}
                </span>
              </div>
              <div className="flex flex-col space-y-1">
                <span className=" text-neutral-500 dark:text-neutral-400">
                {checkOut}
                </span>
                <span className=" font-semibold">
                  {}
                </span>
              </div>
            </div>
          </div>
          <div className="border-l border-neutral-200 dark:border-neutral-700 md:mx-6 lg:mx-10"></div>
          <ul className="text-sm text-neutral-500 dark:text-neutral-400 space-y-1 md:space-y-2">
            <li>Details</li>
            <li>Rooms {data.number_of_rooms} · Guests {data.number_of_guests}</li>
          </ul>
        </div>
      </div>
    );
  };

  const renderDetail = () => {
    if (!isOpen) return null;
    return (
      <div className="p-4 md:p-8 border border-neutral-200 dark:border-neutral-700 rounded-2xl ">
        {renderDetailTop()}
        <div className="my-7 md:my-10 space-y-5 md:pl-24">
          <div className="border-t border-neutral-200 dark:border-neutral-700" />
          <div className="text-neutral-700 dark:text-neutral-300 text-sm md:text-base flex justify-evenly">
            {data.payment_status === 'unpaid'&&(
              <span className="flex justify-center items-center w-10 h-10 text-red-500 font-extrabold text-4xl cursor-pointer" onClick={handleDlete}>
                <i className="la la-trash" aria-hidden="true"></i>
              </span>
            )}
            {data.payment_status === 'unpaid' ? <ButtonPrimary href={"/checkout/"+data.id}>Pay</ButtonPrimary>: <ButtonSecondary disabled>Paid</ButtonSecondary>}
          </div>
          <div className="border-t border-neutral-200 dark:border-neutral-700" />
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-FlightCardgroup p-4 sm:p-6 relative bg-white dark:bg-neutral-900 border border-neutral-100
     dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-lg transition-shadow space-y-6 ${className}`}
      data-nc-id="FlightCard"
    >
      <div
        className={` sm:pr-20 relative  ${className}`}
        data-nc-id="FlightCard"
      >
        {/*  eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a  onClick={() => setIsOpen(!isOpen)} className="absolute inset-0 cursor-pointer" />

        <span
          className={`absolute right-0 bottom-0 sm:bottom-auto sm:top-1/2 sm:-translate-y-1/2 w-10 h-10 bg-neutral-50 dark:bg-neutral-800 rounded-full flex items-center justify-center cursor-pointer ${
            isOpen ? "transform -rotate-180" : ""
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <i className="text-xl las la-angle-down"></i>
        </span>

        <div className="flex  flex-col sm:flex-row sm:items-center space-y-6 sm:space-y-0">
          {/* LOGO IMG */}
          <div className="w-24 lg:w-32 text-neutral-500 flex-shrink-0">
            <i className="text-2xl la la-bookmark" />
          </div>
          {/* FOR MOBILE RESPONSIVE */}
          <div className="block lg:hidden space-y-1">
            <div className="flex font-semibold">
              <div>
                <span>{checkIn}</span>
                <span className="flex items-center text-sm text-neutral-500 font-normal mt-0.5">
                  Check in
                </span>
              </div>
              <span className="w-12 flex justify-center">
                <i className=" text-2xl las la-long-arrow-alt-right"></i>
              </span>
              <div>
                <span>{checkOut}</span>
                <span className="flex items-center text-sm text-neutral-500 font-normal mt-0.5">
                  Check out
                </span>
              </div>
            </div>

            <div className="text-sm text-neutral-500 font-normal mt-0.5">
              <span>Guests: {data.number_of_guests}</span>
              <span className="mx-2">·</span>
              <span>Price:  ${data.daily_price}</span>
              <span className="mx-2">·</span>
              <span>Status: {data.booking_status}</span>
            </div>
          </div>

          {/* TIME - NAME */}
          <div className="hidden lg:block  min-w-[150px] flex-[4] ">
            <div className={`font-medium text-lg ${
              data.booking_status === "ongoing"? "text-green-700": ""
              }`}>{data.booking_status}</div>
            <div className="text-sm text-neutral-500 font-normal mt-0.5">
               Status
            </div>
          </div>

          {/* TIMME */}
          
          <div className="hidden lg:block flex-[4] whitespace-nowrap">
            <div className="font-medium text-lg">
               <span>{checkIn}</span>
               <span className="mx-2">
                <i className=" text-1xl las la-long-arrow-alt-right"></i>
               </span>
               <span>{checkOut}</span>
            </div>
            <div className="text-sm text-neutral-500 font-normal mt-0.5">
              Duration
            </div>
          </div>

          {/* TYPE */}
          {/*
            <div className="hidden lg:block flex-[4] whitespace-nowrap">
            <div className="font-medium text-lg">1 stop</div>
            <div className="text-sm text-neutral-500 font-normal mt-0.5">
              2 hours 15 minutes BKK
            </div>
          </div>
        */}

          {/* PRICE */}
          <div className="flex-[4] whitespace-nowrap sm:text-right">
            <div>
              <span className="text-xl font-semibold text-secondary-6000">
                ${data.total_price}
              </span>
            </div>
            <div className="text-xs sm:text-sm text-neutral-500 font-normal mt-0.5">
              Full stay
            </div>
          </div>
        </div>
      </div>

      {/* DETAIL */}
      {renderDetail()}
    </div>
  );
};

export default BookCard;
